import { PublicationStatus } from 'graphql.generated';
import { LifecycleTagProps } from './LifecycleTag.types';
import { LifecycleTagBadgeLevel, TagWrapper } from './LifecycleTag.styles';

type LifecycleStatus = { label: string; level: LifecycleTagBadgeLevel };

const getLifecycleStatus = (label: string): LifecycleStatus => {
    let level: LifecycleTagBadgeLevel = 'property-status';
    if (label === 'Sold subject to contract') label = 'Sold STC';
    if (label === 'Just added') level = 'colour-block';

    return {
        label,
        level
    };
};

const buildTag = (
    label: string,
    badgeLevel: LifecycleTagBadgeLevel,
    testId: 'listing-status' | 'expired-label' = 'listing-status'
) => (
    <TagWrapper data-testid={testId} badgeLevel={badgeLevel}>
        {label}
    </TagWrapper>
);

const LifecycleTag = ({
    publicationStatus,
    section,
    statusSummary,
    tags
}: LifecycleTagProps) => {
    const lifecycleStatus = statusSummary?.label
        ? getLifecycleStatus(statusSummary.label)
        : null;
    const isExpired = publicationStatus === PublicationStatus.Expired;
    const isNewBuild = section === 'new-homes';
    const isBusiness = Boolean(
        (tags || []).find(({ label }) => label === 'Business for sale')
    );
    const isJustAdded = lifecycleStatus?.label === 'Just added';
    const hasPriorityTag = isJustAdded && (isNewBuild || isBusiness);

    if (isExpired) {
        return buildTag('Expired', 'expired', 'expired-label');
    } else if (lifecycleStatus && !(isJustAdded && hasPriorityTag)) {
        return buildTag(lifecycleStatus.label, lifecycleStatus.level);
    } else if (isNewBuild) {
        return buildTag('New build', 'property-feature');
    } else if (isBusiness) {
        return buildTag('Business', 'property-feature');
    }

    return null;
};

export default LifecycleTag;
export { TagWrapper };
